import type { ReactNode } from 'react';
import { useLocation } from '@/contexts/LocationContext';
import { ProductionCentrePicker } from './ProductionCentrePicker';
import { getSelectedProductionCentre } from '../utils/production-centres';

interface ProductionCentreGateProps {
  children: ReactNode;
}

/**
 * Location-bound production routes share one deliberate All Locations state.
 * Gate before mounting the route so its queries cannot run without a physical
 * floor, and so every operational page offers the same useful way forward.
 */
export function ProductionCentreGate({ children }: ProductionCentreGateProps) {
  const {
    selectedLocation,
    setSelectedLocation,
    locations,
    isLoading,
  } = useLocation();

  const selectedProductionCentre = getSelectedProductionCentre(locations, selectedLocation);

  if (!selectedProductionCentre) {
    return (
      <ProductionCentrePicker
        locations={locations}
        isLoading={isLoading}
        onSelect={setSelectedLocation}
      />
    );
  }

  return <>{children}</>;
}
